import { PASS_MINIMUM_VALUES, PASS_PROPERTY, STEP_UP_LABELS, STEP_UP_MINIMUM_VALUE, STEP_UP_PROPERTY } from "@constants/policy-step-up-constants";
import { RpServiceConfigurationPolicyProperty } from "@idw-types/data/rp-service-configuration/rp-service-configuration-policy-property";
import { FormattedTrustScoreRangeMap } from "@idw-types/formatted-trust-score-range";
import { safelyParseIntFromString } from "@utils/string-util";

export const getSliderMarks = () => {
    const marks = [];
    for (let i = 0; i <= 20; i++) {
        let label = '';
        if (i === 0 || i === 20) {
            label = `${i * 5}`;
        }

        marks.push({
            value: i * 5,
            label
        })
    }

    return marks;
}

export const injectDefaultTrustScoreRangeValues = (properties: Array<RpServiceConfigurationPolicyProperty>, stepUpEnabled: boolean) => {
    return properties.map(property => {
        if (stepUpEnabled) {
            switch (property.name) {
                case PASS_PROPERTY: {
                    property.value = PASS_MINIMUM_VALUES;
                    break;
                }
                case STEP_UP_PROPERTY: {
                    property.value = STEP_UP_MINIMUM_VALUE;
                    break;
                }
            }
        } else {
            switch (property.name) {
                case PASS_PROPERTY: {
                    property.value = PASS_MINIMUM_VALUES;
                    break;
                }
                case STEP_UP_PROPERTY: {
                    property.value = null;
                    break;
                }
            }

            return {
                ...property,
                value: property.name === "stepUp.apiKey" ? "" : property.value
            };
        }
        return property;
    });
}

const parseTrustScoreRangeValue = (value: string | number) => {
    if (typeof value === 'string') {
        value = safelyParseIntFromString(value)
    }

    return value;
}

export const getTrustScoreRangeValues = (policyProperties: Array<RpServiceConfigurationPolicyProperty>) => {
    return policyProperties.reduce((values, property) => {
        if ([STEP_UP_PROPERTY, PASS_PROPERTY].includes(property.name) && property.value !== null) {
            values.push(parseTrustScoreRangeValue(property.value));
        }

        return values;
    }, []);
}

export const getTrustScoreRangeMap = (policyProperties: Array<RpServiceConfigurationPolicyProperty>) => {
    return policyProperties.reduce((properties, property) => {
        if ([STEP_UP_PROPERTY, PASS_PROPERTY].includes(property.name)) {
            properties[property.name] = {
                ...property,
                value: parseTrustScoreRangeValue(property.value),
                label: STEP_UP_LABELS[property.name]
            };
        }

        return properties;
    }, {} as FormattedTrustScoreRangeMap);
}